import { Container, Grid } from "@mui/material";
import React from "react";
import SectionHeading from "../../Components/SectionHeading";

import CMO from "../../images/CMO.png"
import GameLead from "../../images/GameLead.png"
import BlockChainDev from "../../images/BlockChainDev.png"
import GraphicsLead from "../../images/GraphicsLead.png"
import BDM from "../../images/businessDevelopmentManager.png";
import juniorGraphicDesigner from "../../images/juniorGraphicDesigner.png";
import juniorGameDeveloper from "../../images/juniorGameDeveloper.png";

import TeamCards from "../../Components/TeamCards";

const Team = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        className="align-self-center"
                        data-aos="fade-up"
                    >
                        <SectionHeading
                            subHeading = "The people behind all"
                            heading = "Our Team" 
                            customClass = " mx-auto text-center"
                        />
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignContent="center"
                        xs={12}
                        className="pt-3"
                    >
                        <TeamCards 
                            title = "Uzair khan"
                            cardImg = {CMO}
                            // personName = "CMO"
                            personName = "Chief Marketing Officer"
                            socialLink = "https://www.linkedin.com/in/uzair-khan-866335227/"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Nail Oulamine"
                            cardImg = {BlockChainDev}
                            // personName = "CTO"
                            personName = "Chief Technology officer"
                            socialLink = "https://www.linkedin.com/in/nail-oulamine-4292a6229/"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Hinan Niazi"
                            cardImg = {GameLead}
                            personName = "Game Lead"
                            socialLink = "https://www.linkedin.com/in/hinan-khan-6895baa5/"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Raja Sameer"
                            cardImg = {GraphicsLead}
                            personName = "Graphics Lead"
                            socialLink = "https://www.linkedin.com/in/raja-sameer-861013227"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Gul Fraz"
                            cardImg = {BDM}
                            // personName = "BDM"
                            personName = "Business Development Manager"
                            socialLink = "https://www.linkedin.com/in/gul-fraz-3644051b3"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Ramsha Gillani"
                            cardImg = {juniorGraphicDesigner}
                            // personName = "BDM"
                            personName = "Junior Graphic Designer"
                            socialLink = "https://www.linkedin.com/in/ramsha-gillani"
                            cardAnimate = "zoom-in"
                         />
                         <TeamCards 
                            title = "Mohsin Ali"
                            cardImg = {juniorGameDeveloper}
                            // personName = "BDM"
                            personName = "Junior Game Developer"
                            socialLink = "https://www.linkedin.com/in/mohsin-ali-658150156/"
                            cardAnimate = "zoom-in"
                         />
                        {/* <AnnouncementCards 
                            cardDate = "02 Jan, 2022"
                            title = "Tournaments coming"
                            cardImg = {tweet3}
                            link = "#"
                            cardAnimate = "zoom-in"
                        /> */}
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Team;